import React from "react";

import { separatorStyle } from "./separatorStyles.css";

export const Separator = ({ css }: { css?: React.CSSProperties }) => {
  return <div className={separatorStyle} style={css} />;
};
